export enum ResidentialPrimeMenuEnum {
    overview = 0,
    propertyUnitSummaryTransaction,
    landTransaction,
    propertyUnitSummaryRental,
    projectSummaryTable
}
